import React from 'react'
import DatePicker from "react-datepicker";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";

import "./datepicker.scss";

const index = (props) => {
  const ref = React.createRef();

  const { value, name, onChange, minDate, maxDate, placeholderText, width = '', disabled, sDate, isClearable } = props;

  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="input-group" onClick={onClick} ref={ref}>
      <input type="text" name={name} placeholder={placeholderText} autoComplete="off" className="form-control its-custom-inout" defaultValue={value} />
      <div className="input-group-append">
        <span className="input-group-text"><span className="mdi mdi-calendar date-icon"></span></span>
      </div>
    </div>
  ));

  return (
    <div className={`date-picker ${width}`}>
      <DatePicker
        selected={value}
        name={name}
        onChange={onChange}
        className="form-control rounded"
        minDate={minDate}
        maxDate={maxDate}
        style={{borderRadius:"7px"}}
        // popperPlacement={popperPlacement}
        autoComplete="off"
        isClearable={isClearable != undefined ? isClearable : true}
        placeholderText={placeholderText}
        customInput={<CustomInput ref={ref} />}
        dateFormat="yyyy-MM-dd"
        disabled={disabled}
        startDate={sDate != undefined ? sDate : ""}
      />
    </div>
  )
}

export default index;

index.propTypes = {
  data: PropTypes.array,
  name: PropTypes.string,
  placeholderText: PropTypes.string,
  onChange: PropTypes.func,
};
